var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C12.5606 0 0 12.5606 0 28C0 43.4394 12.5606 56 28 56C43.4394 56 56 43.4394 56 28C56 12.5606 43.4394 0 28 0ZM28 53.9259C13.7044 53.9259 2.07407 42.2956 2.07407 28C2.07407 13.7044 13.7044 2.07407 28 2.07407C42.2956 2.07407 53.9259 13.7044 53.9259 28C53.9259 42.2956 42.2956 53.9259 28 53.9259Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3778 18.3629L38.978 26.963H13.4814C12.9089 26.963 12.4443 27.4266 12.4443 28C12.4443 28.5735 12.9089 29.0371 13.4814 29.0371H38.978L30.3778 37.6372L31.8442 39.1036L42.9477 28L31.8442 16.8965L30.3778 18.3629Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.16538e8a4b5e50aaa4578c533b2fa756.svg";
export { ForwardRef as ReactComponent };